const DEFAULT_ACCOUNT_LINKS = {
  accountUrl: undefined,
  logoutUrl: undefined
};

const DEFAULT_SUPPORT_LINKS = {
  createTicketUrl: 'https://managedservices.ctl.io/msp/oauth/login?state=request',
  supportCenterUrl: 'https://managedservices.ctl.io/msp/oauth/login',
  knowledgeBaseUrl: 'https://www.ctl.io/knowledge-base/',
  feedbackUrl: '',
  statusUrl: 'https://status.ctl.io'
};

const BETA_ENVIRONMENT = 'BETA';
const PROD_ENVIRONMENT = 'PROD';

const URL_CONFIG = {
  'PROD': `https://assets.ctl.io/globalnavigation/services.json?${(new Date()).getTime()}`,
  'BETA': `https://assets.ctl.io/globalnavigation/services-beta.json?${(new Date()).getTime()}`
};


export {
  DEFAULT_ACCOUNT_LINKS, DEFAULT_SUPPORT_LINKS,
  BETA_ENVIRONMENT, PROD_ENVIRONMENT,
  URL_CONFIG
};



// WEBPACK FOOTER //
// ./src/scripts/defaults.js